/**
 * Utility functions for JWT token validation
 */

/**
 * Validates JWT token format and expiration
 * @param {string} token - The JWT token to validate
 * @returns {boolean} - True if token is valid, false otherwise
 */
export const isValidToken = (token) => {
    if (!token || typeof token !== 'string') {
        console.log('🔍 Token validation: Token is missing or not a string');
        return false;
    }
    
    if (token.length < 10) {
        console.log('🔍 Token validation: Token is too short');
        return false;
    }
    
    // Basic JWT format check (should have 3 parts separated by dots)
    const parts = token.split('.');
    if (parts.length !== 3) {
        console.log('🔍 Token validation: Invalid JWT format (not 3 parts)');
        return false;
    }
    
    try {
        // Try to decode the payload to check if it's valid JWT
        const payload = JSON.parse(atob(parts[1]));
        
        // Check if token has expired
        if (payload.exp && payload.exp < Date.now() / 1000) {
            console.log('🔍 Token validation: Token has expired');
            return false;
        }
        
        console.log('🔍 Token validation: Token is valid');
        return true;
    } catch (e) {
        console.log('🔍 Token validation: Failed to decode token:', e.message);
        return false;
    }
};

/**
 * Gets a validated token from localStorage
 * @returns {string|null} - The token if valid, null otherwise
 */
export const getValidatedToken = () => {
    const token = localStorage.getItem('token');
    return isValidToken(token) ? token : null;
};

/**
 * Creates authorization headers with validated token
 * @returns {Object|null} - Authorization headers or null if token is invalid
 */
export const getAuthHeaders = () => {
    const token = getValidatedToken();
    if (!token) return null;
    
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
}; 